import { useContext, useEffect } from 'react'
import useAumhumScreen from 'src/clinic/components/ClinicHomePage/hooks/useAumhumScreen'
import { AppUppdatePopupContext } from 'src/components/AppUpdate/AppUpdatePopup'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import {
  setSelectedMicrophoneInLocalStorage,
  setSelectedSpeakerInLocalStorage,
} from 'src/consumer/services/localstorageServices'

const SCREEN_SIGNALING_COMMANDS = {
  REGISTER_SCREEN: 'screen-mgmt.register-screen',
  UNREGISTER_SCREEN: 'screen-mgmt.unregister-screen',
  SEND_HEARTBEAT: 'screen-mgmt.send-heartbeat',
  CHANGE_AUDIO_OUTPUT: 'screen-mgmt.change-audio-output',
  CHANGE_AUDIO_INPUT: 'screen-mgmt.change-audio-input',
  REFRESH_APP: 'screen-mgmt.refresh-app',
  REFRESH_LOGIN_TOKEN: 'screen-mgmt.refresh-login-token',
}

export default function useAumhumScreenSignals(
  regiserScreen,
  setMicrophone,
  setSpeaker,
  thisChamberRoomData,
  thisClinicLocationData,
  refreshLoginToken,
) {
  const { unregisterScreen } = useAumhumScreen()
  const { reSendAppUpdateAction } = useContext(AppUppdatePopupContext)

  useEffect(() => {
    const handleSignalingEvent = async (event) => {
      const command = event?.detail?.command
      const payload = event?.detail?.payload

      console.log('AUMHUM SCREEN SIGNALING EVENT', { command, payload })

      switch (command) {
        case SCREEN_SIGNALING_COMMANDS.REGISTER_SCREEN:
          regiserScreen(thisChamberRoomData, thisClinicLocationData, true)
          break
        case SCREEN_SIGNALING_COMMANDS.UNREGISTER_SCREEN:
          unregisterScreen()
          break
        case SCREEN_SIGNALING_COMMANDS.SEND_HEARTBEAT:
          reSendAppUpdateAction()
          break
        case SCREEN_SIGNALING_COMMANDS.CHANGE_AUDIO_OUTPUT:
          setSelectedSpeakerInLocalStorage(payload?.deviceId)
          setSpeaker(payload?.deviceId)
          window.location.reload()
          break
        case SCREEN_SIGNALING_COMMANDS.CHANGE_AUDIO_INPUT:
          setSelectedMicrophoneInLocalStorage(payload?.deviceId)
          setMicrophone(payload?.deviceId)
          window.location.reload()
          break
        case SCREEN_SIGNALING_COMMANDS.REFRESH_APP:
          window.location.reload()
          break
        case SCREEN_SIGNALING_COMMANDS.REFRESH_LOGIN_TOKEN:
          if (refreshLoginToken) {
            console.log('Received refresh-login-token signal, generating new token...')
            refreshLoginToken()
          } else {
            console.warn('refreshLoginToken function not provided')
          }
          break
        default:
          console.info('Unknown signaling command:', command)
      }
    }

    window.addEventListener(DISPATCH_EVENT_KEYS.aumhumScreenSignalingEvent, handleSignalingEvent)
    return () => {
      window.removeEventListener(
        DISPATCH_EVENT_KEYS.aumhumScreenSignalingEvent,
        handleSignalingEvent,
      )
    }
  }, [thisChamberRoomData, thisClinicLocationData])

  return {}
}
